import React from "react";
import {RadarChartPro} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

// Radar uses a `radar` config object (metrics, max, startAngle) instead of x/y axes,
// so the radar slot lives on this subclass rather than on CCMuiChart.
class CCRadarChart extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["Divisions", "divisions"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onItemClick", "onItemClick"],
        ["ShowToolbar", "showToolbar"],
        ["Shape", "shape"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["Width", "width"],
    ];

    constructor(props: any) {
        super(props);

        this.state.radar = props.radar;
    }

    renderChart(chartProps: any): React.ReactNode {
        return <RadarChartPro {...chartProps} radar={this.state.radar} sx={this.props.sx} />;
    }
}

export default CCRadarChart;
